import React from 'react';
import { Link } from 'react-router-dom';
import '../../pages/legal-pages.css';

export default function PublicLegalFooter() {
  return (
    <footer className="public-legal-footer-min">
      © 2026 Sovrynn LLC ·{' '}
      <Link to="/terms">Terms of Service</Link>
      {' · '}
      <Link to="/privacy">Privacy Policy</Link>
    </footer>
  );
}
